// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconAxoksol } from "../../../icons/full/build/icon-axoksol.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const AxoksolIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconAxoksol.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  AxoksolIcon.displayName = 'AxoksolIcon';
}

export default AxoksolIcon;